module.exports = __webpack_public_path__ + "img/xmen.465d5c26.svg";